if (!customElements.get('compact-product-bundle')) {
  customElements.define(
    'compact-product-bundle',
    class CompactProductBundle extends HTMLElement {
      constructor() {
        super();
    
        this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
      }
    
      get variants() {
        return Array.from(this.querySelectorAll('form[is="product-bundle-form"] [name="id"]'));
      }
    
      get submitButton() {
        return this.querySelector('[data-product-bundle-submit]');
      }
    
      get cartDrawer() {
        return document.querySelector('cart-drawer');
      }
    
      onSubmitHandler(event) {
        const data = {
          items: this.variants.map(variant => ({
            id: variant.value,
            quantity: 1
          }))
        };
    
        if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') {
          theme.utils.postLink2(theme.routes.cart_add_url, {
            parameters: {
              ...data
            }
          });
          return;
        }
        
        event.preventDefault();
        if (this.submitButton.hasAttribute('aria-disabled')) return;
        this.activeElement = event.submitter || event.currentTarget;
    
        this.handleErrorMessage();
    
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        
        const body = JSON.stringify({
          ...data,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });
    
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute('aria-busy', 'true');
    
        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
              
              const submitButtonText = this.submitButton.querySelector('.btn-text span');
              if (!submitButtonText || !submitButtonText.hasAttribute('data-sold-out')) return;
              submitButtonText.innerText = submitButtonText.getAttribute('data-sold-out');
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.error = true;
              return;
            }
    
            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
            cartJson['sections'] = parsedState['sections'];
    
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart: cartJson });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
    
            this.cartDrawer?.show(this.activeElement);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.submitButton.removeAttribute('aria-busy');
    
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }
    
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        
        this.errorMessage = this.errorMessage || this.querySelector('.product-form__error-message');
        if (!this.errorMessage) return;
    
        this.errorMessage.toggleAttribute('hidden', !errorMessage);
        this.errorMessage.innerText = errorMessage;
      }
    }
  );
}

// Bundle Picker Manager - 只处理UI交互，发送事件
class BundlePickerManager {
  constructor() {
    this.bundleContainer = document.querySelector('.bundle-picker-container');
    this.bundleItems = [];
    
    if (!this.bundleContainer) {
      console.warn('[BundlePickerManager] Bundle container not found');
      return;
    }
    
    this.init();
  }

  init() {
    this.collectBundleItems();
    this.updateExposeItemIds();
    this.setupEventListeners();
    this.setupVariantChangeListener();
  }

  collectBundleItems() {
    const items = this.bundleContainer.querySelectorAll('.bundle-product-item');
    
    this.bundleItems = Array.from(items).map(item => {
      const card = item.querySelector('.bundle-product-card');
      const quantityInput = item.querySelector('.quantity-input');
      const minusBtn = item.querySelector('.quantity-btn.minus');
      const plusBtn = item.querySelector('.quantity-btn.plus');
      const checkbox = item.querySelector('.bundle-product-checkbox');
      
      return {
        element: item,
        productId: item.dataset.bundleProductId,
        variantId: item.dataset.bundleVariantId,
        price: parseInt(item.dataset.bundlePrice) || 0,
        compareAtPrice: parseInt(item.dataset.bundleCompareAtPrice) || 0,
        card,
        quantityInput,
        minusBtn,
        plusBtn,
        checkbox
      };
    });
  }

  setupEventListeners() {
    // 使用事件委托方式处理所有交互
    
    // 在bundle容器上监听所有事件 - 使用冒泡阶段（不用捕获）
    this.bundleContainer.addEventListener('click', (e) => {
      // 尝试找到最近的quantity-btn（向上查找，包括SVG/icon等子元素）
      const quantityBtn = e.target.closest('.quantity-btn');
      const bundleCard = e.target.closest('.bundle-product-card');
      const quantityInput = e.target.closest('.quantity-input');
      
      // 点击数量按钮
      if (quantityBtn) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const bundleItem = this.findBundleItemByElement(quantityBtn);
        
        if (!bundleItem) return;
        this.reportBundleQuantityAction(quantityBtn, bundleItem);
        
        const currentValue = parseInt(bundleItem.quantityInput.value) || 1;
        bundleCard.classList.add('checked');
        bundleItem.checkbox.checked = true;
        if (quantityBtn.classList.contains('minus')) {
          if (currentValue > 1) {
            bundleItem.quantityInput.value = currentValue - 1;
            this.dispatchBundleChanged('quantity', bundleItem, currentValue - 1);
          }
        } else if (quantityBtn.classList.contains('plus')) {
          const maxQuantity = bundleItem.quantityInput.getAttribute('max');
          if (currentValue < parseInt(maxQuantity)) {
            bundleItem.quantityInput.value = currentValue + 1;
            this.dispatchBundleChanged('quantity', bundleItem, currentValue + 1);
          }
        }
        return;
      }
      
      // 点击卡片（但不是在输入框上）
      if (bundleCard && !quantityInput && !e.target.closest('.quantity-btn')) {
        e.stopPropagation();
        
        const bundleItem = this.findBundleItemByElement(bundleCard);
        if (!bundleItem) return;
        
        // 切换checked状态
        if (bundleCard.classList.contains('checked')) {
          bundleCard.classList.remove('checked');
          bundleItem.quantityInput.value = 1;
          bundleItem.checkbox.checked = false;
        } else {
          bundleItem.checkbox.checked = true;
          bundleCard.classList.add('checked');
        }
        
        this.dispatchBundleChanged('checkbox', bundleItem, parseInt(bundleItem.quantityInput.value) || 1);
      }
    }, false); // 使用冒泡阶段
    
    // 监听输入框的input事件
    this.bundleContainer.addEventListener('input', (e) => {
      if (e.target.classList.contains('quantity-input')) {
        e.stopPropagation();
        
        const bundleItem = this.findBundleItemByElement(e.target);
        const maxQuantity = parseInt(bundleItem.quantityInput.getAttribute('max'));
        if (!bundleItem) return;
        bundleItem.card.classList.add('checked');
        bundleItem.checkbox.checked = true;
        let value = parseInt(e.target.value) || 1;
        if (value < 1) {
          value = 1;
          e.target.value = value;
        }
        if (value > maxQuantity) {
          value = maxQuantity;
          e.target.value = value;
        }
        
        this.dispatchBundleChanged('quantity', bundleItem, value);
      }
    }, false); // 使用冒泡阶段
  }

  // 根据元素找到对应的bundleItem
  setupVariantChangeListener() {
    document.addEventListener('variant:change', (event) => {
      const variantId = event.detail?.variant?.id;
      if (!variantId) return;

      this.updateExposeItemIds(variantId);
    }, true);
  }

  getCurrentMainVariantId() {
    const selectedVariantNode = this.bundleContainer.closest('product-info')?.querySelector('[data-selected-variant]');
    if (!selectedVariantNode?.textContent) return '';

    try {
      return String(JSON.parse(selectedVariantNode.textContent).id || '');
    }
    catch (error) {
      return '';
    }
  }

  updateExposeItemIds(mainVariantId = this.getCurrentMainVariantId()) {
    if (!mainVariantId) return;

    this.bundleItems.forEach((bundleItem) => {
      if (!bundleItem.card || !bundleItem.variantId) return;

      bundleItem.card.dataset.mainVariantId = String(mainVariantId);
      bundleItem.card.dataset.exposeItemId = `${mainVariantId}_${bundleItem.variantId}`;
    });
  }

  reportBundleQuantityAction(button, bundleItem) {
    if (!button || !bundleItem || !window.Expose || typeof window.Expose.reportAction !== 'function') return;

    const mainVariantId = bundleItem.card?.dataset.mainVariantId || this.getCurrentMainVariantId();
    if (!mainVariantId || !bundleItem.variantId) return;

    const action = {
      action_type: button.dataset.bundleQuantityAction || 'click',
      item_id: `${mainVariantId}_${bundleItem.variantId}`,
      exinfo1: JSON.stringify({
        source: new URLSearchParams(window.location.search).get('source') || '',
        url: window.location.href
      })
    };
    const options = {
      keepalive: true
    };
    const payloadPromise = typeof window.Expose.buildExposureAction === 'function'
      ? window.Expose.buildExposureAction(action, bundleItem.card, options)
      : Promise.resolve(action);

    payloadPromise
      .then((payload) => window.Expose.reportAction(payload, options))
      .catch((error) => {
        console.warn('Bundle quantity report failed:', error);
      });
  }

  findBundleItemByElement(element) {
    const bundleItem = element.closest('.bundle-product-item');
    if (!bundleItem) return null;
    
    return this.bundleItems.find(item => item.element === bundleItem);
  }

  // 分派bundle改变事件
  dispatchBundleChanged(type, bundleItem, quantity) {
    document.dispatchEvent(new CustomEvent('bundlePicker:changed', {
      detail: {
        type: type,
        productId: bundleItem.productId,
        variantId: bundleItem.variantId,
        checked: bundleItem.card?.classList.contains('checked') || false,
        quantity: quantity,
        price: bundleItem.price,
        compareAtPrice: bundleItem.compareAtPrice
      }
    }));
  }

  resetAll() {
    this.bundleItems.forEach(bundleItem => {
      if (bundleItem.card.classList.contains('checked')) {
        bundleItem.card.classList.remove('checked');
      }
      if (bundleItem.checkbox) {
        bundleItem.checkbox.checked = false;
      }
      if (bundleItem.quantityInput) {
        bundleItem.quantityInput.value = 1;
      }
    });
  }

  getSelectedBundles() {
    return this.bundleItems
      .filter(bundleItem => bundleItem.card.classList.contains('checked'))
      .map(bundleItem => ({
        variantId: bundleItem.variantId,
        productId: bundleItem.productId,
        price: bundleItem.price,
        compareAtPrice: bundleItem.compareAtPrice,
        quantity: parseInt(bundleItem.quantityInput.value) || 1
      }));
  }

  calculateBundlePrice() {
    const price = this.getSelectedBundles().reduce((total, bundle) => {
      return total + (bundle.price * bundle.quantity);
    }, 0);

    const compareAtPrice = this.getSelectedBundles().reduce((total, bundle) => {
      return total + (bundle.compareAtPrice * bundle.quantity);
    }, 0);
    return {
      price,
      compareAtPrice
    }
  }
}

// 初始化
let bundlePickerManager = null;

document.addEventListener('DOMContentLoaded', () => {
  bundlePickerManager = new BundlePickerManager();
});
